/**
 * Contains customizations to the main product component:
 * - switches between product images based on the selected variant.
 * - allows for showing/hiding the critical reviews section based on the selected variant.
 * - allows for showing/hiding the about the author section based on the selected variant.
 * - allows for showing/hiding the publishing information section based on the selected variant.
 *
 * Do note that there is a matching brand-main-product.css file in the assets folder
 * that contains relevant styles used with this customizations.
 */

const BrandMainProduct = {
  SELECTORS: {
    variantPicker: '[data-js-variant-picker]',
    variantOption: '[data-js-variant-option]',
    variantCriticalReviewsContainer: '[data-js-variant-critical-reviews-container]',
    variantAboutTheAuthorContainer: '[data-js-variant-about-the-author-container]',
    variantPublishingInformationContainer: '[data-js-variant-publishing-information-container]',
    variantOptionId: '[data-js-variant-option-id]',
    variantOptionProductId: '[data-js-variant-option-product-id]',
    variantOptionMediaId: '[data-js-variant-option-media-id]',
    variantOptionEan: '[data-js-variant-option-ean',
    variantOptionReviews: '[data-js-variant-option-reviews]',
    variantOptionBiographicalNote: '[data-js-variant-option-biographical-note]',
    variantOptionPublisher: '[data-js-variant-option-publisher]',
    variantOptionPreorderBlurb: '[data-js-variant-option-preorder-blurb]',
    variantOptionIsPersonalized: '[data-js-variant-option-personalized]',
    variantOptionPublicationDate: '[data-js-variant-option-publication-date]',
    variantOptionPageCount: '[data-js-variant-option-page-count]',
    variantPreorderBlurbContainer: '[data-js-variant-preorder-blurb-container]',
    variantPersonalizationContainer: '[data-js-variant-personalization-container]',
    variantReviewsContainer: '[data-js-variant-reviews-container]',
    variantBiographicalNoteContainer: '[data-js-variant-biographical-note-container]',
    variantPublisherContainer: '[data-js-variant-publisher-container]',
    variantPublicationDateContainer: '[data-js-variant-publication-date-container]',
    variantPageCountContainer: '[data-js-variant-page-count-container]',
  },
  CLASSES: {
    elementHidden: 'hidden',
  },
  init() {
    this.initializeVariantPicker();
  },
  initializeVariantPicker() {
    const variantPickerElements = document.querySelectorAll(this.SELECTORS.variantPicker);

    variantPickerElements.forEach((variantPickerElement) => {
      variantPickerElement.onchange = (event) => {
        this.handleImage(event.target);
        this.handlePreorderBlurb(event.target);
        this.handlePersonalization(event.target);
        this.handleCriticalReviews(event.target);
        this.handleAboutTheAuthor(event.target);
        this.handlePublishingInformation(event.target);
      };
    });
  },
  handleImage(variantPickerElement) {
    const currentOptionElement = variantPickerElement.options[variantPickerElement.selectedIndex];

    const currentVariantId = currentOptionElement.getAttribute(
      this.SELECTORS.variantOptionId.replace('[', '').replace(']', '')
    );

    window.ProductSwiper.slideToVariantImage(currentVariantId);
  },
  handleCriticalReviews(variantPickerElement) {
    const currentOptionElement = variantPickerElement.options[variantPickerElement.selectedIndex];

    const currentReviews = currentOptionElement
      .getAttribute(this.SELECTORS.variantOptionReviews.replace('[', '').replace(']', ''))
      .trim();

    if (currentReviews === '' || currentReviews.match(/^No reviews \d\d\d\d-\d\d-\d\d$/)) {
      // If there are not reviews, or we checked for reviews more than a month ago, pull reviews
      if (
        currentReviews.length === 0 ||
        Date.now() - Date.parse(currentReviews.slice(-10)) > 30 * 24 * 60 * 60 * 1000
      ) {
        const currentVariantId = currentOptionElement.getAttribute(
          this.SELECTORS.variantOptionId.replace('[', '').replace(']', '')
        );
        const currentVariantMediaId = currentOptionElement.getAttribute(
          this.SELECTORS.variantOptionMediaId.replace('[', '').replace(']', '')
        );
        const currentVariantProductId = currentOptionElement.getAttribute(
          this.SELECTORS.variantOptionProductId.replace('[', '').replace(']', '')
        );
        const currentVariantEan = currentOptionElement.getAttribute(
          this.SELECTORS.variantOptionEan.replace('[', '').replace(']', '')
        );
        fetch('/apps/customer-actions/add_reviews', {
          method: 'POST',
          body: JSON.stringify({
            ean: currentVariantEan,
            product_id: currentVariantProductId,
            variant_id: currentVariantId,
            media_id: currentVariantMediaId,
          }),
        });
      }
    }

    const variantCriticalReviewsContainer = document.querySelector(this.SELECTORS.variantCriticalReviewsContainer);
    const variantReviewsContainer = document.querySelector(this.SELECTORS.variantReviewsContainer);

    if (variantCriticalReviewsContainer) {
      if (currentReviews) {
        try {
          reviewsHTML = JSON.parse(currentReviews).join('<p/>');
        } catch (error) {
          reviewsHTML = currentReviews;
        }
        variantCriticalReviewsContainer.classList.remove(this.CLASSES.elementHidden);
      } else {
        reviewsHTML = '';
        variantCriticalReviewsContainer.classList.add(this.CLASSES.elementHidden);
      }
      variantReviewsContainer.innerHTML = reviewsHTML;
    }
  },
  handlePreorderBlurb(variantPickerElement) {
    const currentOptionElement = variantPickerElement.options[variantPickerElement.selectedIndex];

    const currentPreorderBlurb = currentOptionElement
      .getAttribute(this.SELECTORS.variantOptionPreorderBlurb.replace('[', '').replace(']', ''))
      .trim();
    const variantPreorderBlurbContainer = document.querySelector(this.SELECTORS.variantPreorderBlurbContainer);

    if (variantPreorderBlurbContainer) {
      variantPreorderBlurbContainer.innerHTML = currentPreorderBlurb;
    }
  },
  handlePersonalization(variantPickerElement) {
    const currentOptionElement = variantPickerElement.options[variantPickerElement.selectedIndex];

    const currentPersonalized =
      currentOptionElement
        .getAttribute(this.SELECTORS.variantOptionIsPersonalized.replace('[', '').replace(']', ''))
        .trim()
        .toLowerCase() === 'true';
    const variantPersonalizationContainer = document.querySelector(this.SELECTORS.variantPersonalizationContainer);

    if (variantPersonalizationContainer) {
      if (currentPersonalized) {
        variantPersonalizationContainer.classList.remove(this.CLASSES.elementHidden);
        variantPersonalizationContainer.querySelector('input').removeAttribute('disabled');
      } else {
        variantPersonalizationContainer.classList.add(this.CLASSES.elementHidden);
        variantPersonalizationContainer.querySelector('input').setAttribute('disabled', 'true');
      }
    }
  },
  handleAboutTheAuthor(variantPickerElement) {
    const currentOptionElement = variantPickerElement.options[variantPickerElement.selectedIndex];

    const currentBiographicalNote = currentOptionElement
      .getAttribute(this.SELECTORS.variantOptionBiographicalNote.replace('[', '').replace(']', ''))
      .trim();
    const variantAboutTheAuthorContainer = document.querySelector(this.SELECTORS.variantAboutTheAuthorContainer);
    const variantBiographicalNoteContainer = document.querySelector(this.SELECTORS.variantBiographicalNoteContainer);

    if (variantBiographicalNoteContainer) {
      variantBiographicalNoteContainer.innerHTML = currentBiographicalNote;

      if (currentBiographicalNote) {
        variantAboutTheAuthorContainer.classList.remove(this.CLASSES.elementHidden);
      } else {
        variantAboutTheAuthorContainer.classList.add(this.CLASSES.elementHidden);
      }
    }
  },
  handlePublishingInformation(variantPickerElement) {
    const currentOptionElement = variantPickerElement.options[variantPickerElement.selectedIndex];

    const currentVariantPublisher = currentOptionElement
      .getAttribute(this.SELECTORS.variantOptionPublisher.replace('[', '').replace(']', ''))
      .trim();
    const variantPublisherContainer = document.querySelector(this.SELECTORS.variantPublisherContainer);

    if (variantPublisherContainer) {
      variantPublisherContainer.innerHTML = currentVariantPublisher;

      if (currentVariantPublisher) {
        variantPublisherContainer.closest('div').classList.remove(this.CLASSES.elementHidden);
      } else {
        variantPublisherContainer.closest('div').classList.add(this.CLASSES.elementHidden);
      }
    }

    const currentVariantPublicationDate = currentOptionElement
      .getAttribute(this.SELECTORS.variantOptionPublicationDate.replace('[', '').replace(']', ''))
      .trim();
    const variantPublicationDateContainer = document.querySelector(this.SELECTORS.variantPublicationDateContainer);

    if (variantPublicationDateContainer) {
      variantPublicationDateContainer.innerHTML = currentVariantPublicationDate;

      if (currentVariantPublicationDate) {
        variantPublicationDateContainer.closest('div').classList.remove(this.CLASSES.elementHidden);
      } else {
        variantPublicationDateContainer.closest('div').classList.add(this.CLASSES.elementHidden);
      }
    }

    const currentVariantPageCount = currentOptionElement
      .getAttribute(this.SELECTORS.variantOptionPageCount.replace('[', '').replace(']', ''))
      .trim();
    const variantPageCountContainer = document.querySelector(this.SELECTORS.variantPageCountContainer);

    if (variantPageCountContainer) {
      variantPageCountContainer.innerHTML = currentVariantPageCount;

      if (currentVariantPageCount) {
        variantPageCountContainer.closest('div').classList.remove(this.CLASSES.elementHidden);
      } else {
        variantPageCountContainer.closest('div').classList.add(this.CLASSES.elementHidden);
      }
    }

    const variantPublishingInformationContainer = document.querySelector(
      this.SELECTORS.variantPublishingInformationContainer
    );

    if (currentVariantPublisher || currentVariantPublicationDate || currentVariantPageCount) {
      variantPublishingInformationContainer.classList.remove(this.CLASSES.elementHidden);
    } else {
      variantPublishingInformationContainer.classList.add(this.CLASSES.elementHidden);
    }
  },
};

window.addEventListener('DOMContentLoaded', () => {
  BrandMainProduct.init();
});

document.addEventListener('shopify:section:load', () => {
  BrandMainProduct.init();
});

document.addEventListener('shopify:section:reorder', () => {
  BrandMainProduct.init();
});
